import { GlButton, GlButtonGroup, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { jumpToQuestion } from 'ee/work_items/utils/question_navigation';
import { QUESTION_NAVIGATION_NEXT, QUESTION_NAVIGATION_PREVIOUS } from 'ee/work_items/constants';
export default {
    name: 'WorkplanQuestionNavigator',
    components: {
        GlButton,
        GlButtonGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        questions: {
            type: Array,
            required: true
        }
    },
    computed: {
        openNoteIds () {
            return this.questions.filter(({ answered })=>!answered).map(({ noteId })=>noteId);
        }
    },
    methods: {
        jump (direction) {
            jumpToQuestion({
                noteIds: this.openNoteIds,
                direction
            });
        }
    },
    QUESTION_NAVIGATION_NEXT,
    QUESTION_NAVIGATION_PREVIOUS
};
